import { PanelLeftClose, PanelLeftOpen } from "lucide-react";

import { Card } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import useStoredFlag from "@/hooks/useStoredFlag";

// Per-browser convenience: folded stays folded from one candidate to the next.
const STORAGE_KEY = "candidateAnalysis.profileCollapsed";

/**
 * The left-hand profile card on candidate analysis. Folds to a thin rail so
 * the tabs get the full width, and opens again from the rail.
 */
const CollapsibleProfileCard = ({ children }) => {
  const [collapsed, toggle] = useStoredFlag(STORAGE_KEY);

  const Icon = collapsed ? PanelLeftOpen : PanelLeftClose;

  return (
    <Card
      className={cn(
        "relative hidden shrink-0 flex-col overflow-hidden border-r border-border-primary bg-background-secondary md:flex p-0 transition-[width] duration-200",
        collapsed ? "w-12 items-center" : "w-[330px]",
      )}
    >
      <Button
        type="button"
        onClick={toggle}
        aria-label={collapsed ? "Show profile" : "Hide profile"}
        aria-expanded={!collapsed}
        title={collapsed ? "Show profile" : "Hide profile"}
        className={cn(
          "z-10 flex h-8 w-8 items-center justify-center rounded-lg p-0 text-text-secondary hover:bg-background-tertiary hover:text-text-primary",
          collapsed ? "mt-3" : "absolute right-2 top-2",
        )}
      >
        <Icon size={16} />
      </Button>

      {!collapsed && children}
    </Card>
  );
};

export default CollapsibleProfileCard;
